import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getResourcesTags() {
      return getState().tags;
    },
    isRetrieveResourcesTagsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveResourcesTagsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveResourcesTagsRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
